// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.btn {\n  margin-right: 1rem;\n}\n", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAAA,8EAAA;AACA;EACI,kBAAkB;AACtB","file":"styles.scss","sourcesContent":["/* You can add global styles to this file, and also import other style files */\r\n.btn {\r\n    margin-right: 1rem;\r\n}"]}]);
// Exports
module.exports = exports;
